import { render, staticRenderFns } from "./AutoFormSaveComponent.vue?vue&type=template&id=881b9620&"
import script from "./AutoFormSaveComponent.vue?vue&type=script&lang=js&"
export * from "./AutoFormSaveComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports